export default "__VITE_ASSET__7a00dab0__"